import { AxiosInstance } from 'axios';

import { axios } from '../../../../api/axios-instance';
import { sizeEndpoints } from '../../../../constants';
import { DeleteItemsInput } from '../../../../types';
import { ISize, ISizes } from '../../entities/size';
import { CreateSizeInput } from '../../schemas/size.schema';

class SizesApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  create = async (size: CreateSizeInput): Promise<ISize> => {
    return this.#requestInstance.post(sizeEndpoints.size, size);
  };

  getSizes = async (): Promise<ISizes> => {
    return this.#requestInstance.get(sizeEndpoints.size);
  };

  deleteSize = async (id: number): Promise<void> => {
    return this.#requestInstance.delete(sizeEndpoints.getSizeById(id));
  };

  deleteManySizes = async (input: DeleteItemsInput): Promise<void> => {
    return this.#requestInstance.delete(sizeEndpoints.size, { data: input });
  };

  getSizeById = async (id: number): Promise<ISize> => {
    return this.#requestInstance.get(sizeEndpoints.getSizeById(id));
  };

  updateSize = async (size: ISize): Promise<ISize> => {
    return this.#requestInstance.patch(sizeEndpoints.getSizeById(size.id), { name: size.name });
  };
}

export const sizesApi = new SizesApi(axios);
